import { LitElement, html, css} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';
import '../../voyage-spinner/src/voyage-spinner';

@customElement("voyage-popup")
export class VoyagePopup extends LitElement
{
    @property({ type: Boolean, reflect: true }) shown: boolean = false;
    @property({ type: String, attribute: "header-text" }) headerText: string = "";
    @property({ type: Boolean, attribute: "no-header" }) noHeader: boolean = false;
    @property({ type: Boolean, attribute: "no-footer" }) noFooter: boolean = false;
    @property({ type: Boolean, attribute: "no-close-button" }) noCloseButton: boolean = false;
    @property({ type: String, attribute: "accept-button-text" }) acceptButtonText: string = "OK";
    @property({ type: Boolean, attribute: "no-accept-button" }) noAcceptButton: boolean = false;
    @property({ type: String, attribute: "reject-button-text" }) rejectButtonText: string = "Cancel";
    @property({ type: String, attribute: "secondary-button-text" }) secondaryButtonText: string = "";
    @property({ type: Boolean, attribute: "disable-accept-button" },) disableAcceptButton: boolean = false;
    @property({ type: Boolean, attribute: "no-overflow" }) noOverflow: boolean = false;
    @property({ type: Boolean }) loading: boolean = false;
    @property({ type: Boolean, attribute: "no-header-box" }) noHeaderBox: boolean = false;    

    
    constructor()
    {
        super();

        this.addEventListener("click", () => {
            if (!this.noCloseButton)
            {
                this.close();
            }
        });
    }

    static get styles() {
        return [
            css`
            :host {
                display: none;
                position: fixed;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                justify-content: center;
                align-items: center;
                z-index: 600;

                background: rgba(0, 0, 0, 0.6);
            }

            :host([shown]) {
                display: flex;
            }

            svg {
                display: block;
            }

            #closeButton {
                position: absolute;
                top: 21px;
                right: 24px;
                padding: 0;
                background: none;
                border: none;
                outline: none;
                cursor: pointer;
                fill: var(--neutrals-grey-04, grey);
            }

            #closeButton > svg {
                display: block;
                width: 10px;
            }

            .header {
                font-family: var(--component-paragraph-ff, serif);
                color: var(--neutrals-grey-02, black);
                font-size: 16px;
                line-height: 24px;
                padding-top: 16px;
                padding-bottom: 16px;
                padding-left: 24px;
                margin: 0;
                display: flex;
                padding-right:30px;
            }

            .header-box {
                background: var(--neutrals-grey-09);
                border-bottom: 1px solid var(--neutrals-grey-07);
                border-radius: 5px;
            }

            .header-box {
                background: var(--neutrals-grey-09);
                border-bottom: 1px solid var(--neutrals-grey-07);
                border-radius: 5px;
            }

            #container {
                position: relative;
                display: flex;
                flex-direction: column;
                box-sizing: border-box;
                width: fit-content;
                height: fit-content;
                max-height: 100%;
                max-width: 100%;
                border-radius: 6px;
                border: 1px solid var(--neutrals-grey-06, black);
                box-shadow: 5px 5px 10px rgba(0,0,0,0.5);
                background: var(--neutrals-grey-10, white);
            }

            #content {
                width: fit-content;
                height: fit-content;
                flex-shrink: 1;
            }

            #content[overflow] {
                overflow: auto;
            }

            #footer {
                width: 100%;
                display: flex;
                justify-content: flex-end;
                background: var(--neutrals-grey-09);
                border-radius: 5px;
            }

            .footerButton {
                margin-top: 12px;
                margin-bottom: 12px;
                height: 32px;
                font-size: 14px;
                font-family: var(--component-paragraph-ff, serif);
                padding: 0px 24px 0px 0px;
                background: none;
                border: none;
                outline: none;
                cursor: pointer;
                border-radius: 3px;
            }

            .cancel {
                color: var(--neutrals-grey-02);
                margin-right: 10px;
                border: 1px solid var(--neutrals-grey-06, grey);
            }

            .accept {
                background: var(--primary-blue-05, blue);
                margin-right: 20px;
                color: var(--neutrals-grey-10, white);
            }

            .accept[disabled] {
                background: var(--primary-blue-300, lightblue);
                cursor: auto;
            }

            .loadingOverlay {
                position: absolute;
                top: -1px;
                bottom: -1px;
                right: -1px;
                left: -1px;
                z-index: 10;
                background-color: rgba(var(--neutrals-grey-01-rgb), 0.5);
                border-radius: 3px;
            }

            voyage-spinner {
                width: 50px;
                height: 50px;
                left: calc(50% - 25px);
                top: calc(50% - 25px);
                position: absolute;
            }
        `];
    }

    render()
    {
        return html`
        <div id="container"  @click=${ (event: MouseEvent) => event.stopPropagation()}> 
        ${this.noHeader ? html ``: html `<div id="headerContainer" @click=${ (event: MouseEvent) => event.stopPropagation() }>
            ${this.noCloseButton ? html`` : html`
            <button id="closeButton" @click=${() => this.close() }>
                ${SvgIcons.lightTimes}
            </button>`}    
            ${!this.headerText ? html`` : html`
            <slot name="header ${!this.noHeaderBox ? 'header-box' : ''}">
                <h1 class="header">
                    ${this.headerText}
                </h1>
            </slot>
            `}
         </div>
         `}
            <div id="content" ?overflow=${!this.noOverflow}>
                <slot></slot>
            </div>
            ${this.noFooter ? html`` : html`
            <slot name="footer">
                <div id="footer">
                    ${this.rejectButtonText? html` <mc-button class="footerButton cancelButton"  appearance="neutral" variant="outlined" @click=${ () => this.close() }>${this.rejectButtonText}</mc-button>`: ""}
                    ${this.secondaryButtonText ? html`<mc-button class="footerButton " appearance="secondary" ?disabled=${this.disableAcceptButton} @click=${ () => this.secondaryAction() }>${this.secondaryButtonText}</mc-button>` : ""}
                    ${!this.noAcceptButton ? html`<mc-button class="footerButton acceptButton" appearance="primary" ?disabled=${this.disableAcceptButton} @click=${ () => this.accept() }>${this.acceptButtonText}</mc-button>` : ""}
                </div>
            </slot>
            `}
            ${this.loading ? html`
            <div class="loadingOverlay">
                <voyage-spinner></voyage-spinner>
            </div>` : html``}
        </div>
    </div>
        `;
    }

    accept()
    {
        if (!this.loading)
        {
            this.dispatchEvent(new Event("accept"));
        }
    }

    close()
    {
        this.dispatchEvent(new Event("close"));
    }

    secondaryAction()
    {
        this.dispatchEvent(new Event("secondaryAction"));
    }

    scrollTo(...args: any[])
    {
        const content = this.shadowRoot!.getElementById("content");
        if (content)
        {
            content.scrollTo(...args);
        }
    }
}
